import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { PopupCall } from "./PopupCall";
import { PopupClientEdit } from "./PopupClientEdit";
import { sendClarityEvent, sendGTMEvent } from "../utils/analytics";
import { routes } from "../utils/symbols";
import { t } from "../i18n";

export const Footer = ({ nextPage, previousPage: initialPreviousPage }) => {
	const {
		openPopUpCall,
		route,
		navigate,
		data,
		setData,
		setIsTransitioning,
		validateForm,
		FLOW,
	} = useContext(AppContext);
	const [disabledButton, setDisabledButton] = useState(false);
	const [previousPage, setPreviousPage] = useState(initialPreviousPage);
	const [sending, setSending] = useState(false);

	useEffect(() => {
		let newPreviousPage = initialPreviousPage;

		if (route === "selectDateTime" && data.damageArea === "repair") {
			newPreviousPage = "damageArea";
		}
		if (route === "selectDateTime" && data.damageArea === "replacement") {
			newPreviousPage = "damageArea";
		}
		if (
			route === "selectDateTime" &&
			data.damageArea === "replacement" &&
			data.damageType === "large"
		) {
			newPreviousPage = "damageType";
		}
		if (
			route === "selectDateTime" &&
			data.damageGlass !== "Parabrisas delantero"
		) {
			newPreviousPage = "damageGlass";
		}

		setPreviousPage(newPreviousPage);
	}, [route, data, initialPreviousPage]);

	useEffect(() => {
		let isDisabled = false;
		if (sending) {
			isDisabled = true;
		}

		if (
			route === "bookingForm" &&
			FLOW === "web" &&
			(!data.phone ||
				!data.plate ||
				!data.brand ||
				!data.model ||
				!data.privacy_policy)
		)
			isDisabled = true;
		if (
			route === "bookingForm" &&
			FLOW === "mapfre" &&
			(!(data.userName || data.name) ||
				!(data.phoneNumber || data.phone) ||
				!(data.userEmail || data.email) ||
				!(data.plateNumber || data.plate) ||
				!data.workCenterCode)
		)
			isDisabled = true;
		if (route === "selectCenter" && !data.centerId) isDisabled = true;
		if (route === "damageGlass" && !data.damageGlass) isDisabled = true;
		if (route === "damageType" && !data.damageType) isDisabled = true;
		if (route === "damageArea" && !data.damageArea) isDisabled = true;
		if (route === "selectDateTime" && (!data.date || !data.time))
			isDisabled = true;
		if (
			route === "bookingEnd" &&
			(!data.plate ||
				!(data.insurance || data.noInsurance) ||
				!data.email ||
				!data.name ||
				!data.phone ||
				!data.privacy_policy_2)
		)
			isDisabled = true;

		setDisabledButton(isDisabled);
	}, [route, data, sending, FLOW]);

	const goToPreviousPage = () => {
		if (route === "bookingEnd")
			setData({
				...data,
				insurance: null,
				noInsurance: false,
				name: null,
				phone: null,
			});
		if (route === "selectDateTime")
			setData({
				...data,
				date: null,
				time: null,
				startTime: null,
				endTime: null,
			});
		if (route === "damageArea") setData({ ...data, damageArea: null });
		if (route === "damageType") setData({ ...data, damageType: null });
		if (route === "damageGlass") setData({ ...data, damageGlass: null });
		if (route === "selectCenter")
			setData({
				...data,
				centerId: null,
				centerName: null,
				centerCode: null,
			});

		setIsTransitioning(false);
		navigate(previousPage);
	};

	const goToNextPage = async () => {
		setSending(true);
		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		};

		if (route === "bookingForm") {
			if (!validateForm()) {
				console.log("Formulario con errores, deteniendo navegación...");
				setSending(false);
				return;
			}

			if (!data.locator) {
				let TOKEN = process.env.REACT_APP_API_TOKEN;

				const controller = new AbortController();
				const requestOptions = {
					...options,
					body: JSON.stringify({
						...data,
						token: TOKEN,
					}),
					signal: controller.signal,
				};

				const url =
					FLOW === "mapfre"
						? `${API_URL}/bookings/mapfre`
						: `${API_URL}/bookings`;

				try {
					const res = await fetch(url, requestOptions);
					const newData = await res.json();
					if (newData.result === "ok") {
						setData((prevData) => ({
							...prevData,
							locator: newData.locator,
						}));
					}
				} catch (err) {
					if (err.name !== "AbortError") console.error(err);
				}
			}
		}

		if (data.locator) {
			try {
				const controller = new AbortController();
				const bookingRes = await fetch(
					`${API_URL}/bookings/${data.locator}`,
					{
						...options,
						signal: controller.signal,
					}
				);
				await bookingRes.json();
			} catch (err) {
				if (err.name !== "AbortError") console.error(err);
			}
		}

		if (nextPage === "selectDateTime") {
			try {
				const controller = new AbortController();
				const sendRes = await fetch(`${API_URL}/send/${data.locator}`, {
					...options,
					signal: controller.signal,
				});
				await sendRes.json();
			} catch (err) {
				if (err.name !== "AbortError") console.error(err);
			}
		}

		if (
			(route === "selectDateTime" &&
				FLOW === "mapfre" &&
				data.date &&
				data.time &&
				data.locator) ||
			(route === "bookingEnd" && FLOW === "web")
		) {
			if (route === "bookingEnd" && FLOW === "web" && !validateForm()) {
				console.log("Formulario con errores, deteniendo navegación...");
				setSending(false);
				return;
			}

			try {
				const controller = new AbortController();
				const sendRes = await fetch(
					`${API_URL}/finish/${data.locator}`,
					{
						...options,
						signal: controller.signal,
					}
				);
				const responseData = await sendRes.json();

				if (route === "bookingEnd" && sendRes.status === 400) {
					setIsTransitioning(false);
					setSending(false);
					navigate(routes.errorPage);
					return;
				}

				if (
					responseData.result === "ok" &&
					responseData.booking?.code
				) {
					setData((prevData) => ({
						...prevData,
						code: responseData.booking.code,
					}));
				}
			} catch (err) {
				if (err.name !== "AbortError") console.error(err);
			}
		}

		if (route === "bookingForm") {
			sendClarityEvent("fc-vehiculo");
			sendGTMEvent("fc-vehiculo", {
				origin: data.origin,
				locator: data.locator,
			});
		} else if (route === "selectCenter") {
			sendClarityEvent("fc-taller");
			sendGTMEvent("fc-taller", {
				origin: data.origin,
				locator: data.locator,
			});
		} else if (route === "damageGlass") {
			const tag =
				data.damageGlass === "Parabrisas delantero"
					? "Reparacion (provisional)"
					: "Sustitucion";
			sendClarityEvent("fc-cristal");
			sendClarityEvent("fc-cristal:", data.damageGlass);
			sendClarityEvent(tag);
			sendGTMEvent("fc-cristal", {
				origin: data.origin,
				locator: data.locator,
			});
		} else if (route === "damageType") {
			const damageType =
				data.damageType === "small"
					? "Menor que una moneda de 2€"
					: "Mayor que una moneda de 2€";
			const tag =
				data.damageType === "small"
					? "Reparacion (provisional)"
					: "Sustitucion";
			sendClarityEvent("fc-dano");
			sendClarityEvent("fc-dano:", damageType);
			sendClarityEvent(tag);
			sendGTMEvent("fc-dano", {
				origin: data.origin,
				locator: data.locator,
			});
		} else if (route === "damageArea") {
			const damageArea =
				data.damageArea === "repair" ? "Reparacion" : "Sustitucion";
			sendClarityEvent("fc-area");
			sendClarityEvent("fc-area:", damageArea);
			sendClarityEvent(damageArea);
			sendGTMEvent("fc-area", {
				origin: data.origin,
				locator: data.locator,
			});
		} else if (route === "selectDateTime") {
			sendClarityEvent("fc-cita");
			sendGTMEvent("fc-cita", {
				origin: data.origin,
				locator: data.locator,
			});
		} else if (route === "bookingEnd") {
			sendClarityEvent("fc-cliente");
			sendGTMEvent("fc-cliente", {
				origin: data.origin,
				locator: data.locator,
			});
		}

		setIsTransitioning(false);
		setSending(false);
		navigate(nextPage);
	};

	return (
		<>
			<footer className="footer">
				<div className="footer_wrapper">
					<div className="footer_left">
						<button
							onPointerDown={openPopUpCall}
							className={
								"footer_call" +
								(!data.locator ? " disabled" : "")
							}
						>
							<img
								className="footer_icon"
								src="resources/icons/telephone.svg"
								alt="Solicitar llamada"
							/>
							<p className="footer_p">{t("Solicitar llamada")}</p>
						</button>
					</div>
					<div className="footer_right">
						<button
							className={
								"nav_previous kensei_03" +
								(!data.locator ||
								route === "bookingForm" ||
								(FLOW === "mapfre" &&
									data.locator &&
									route === "intro")
									? " disabled"
									: "")
							}
							onPointerDown={goToPreviousPage}
						>
							<img
								className="footer_icon"
								src="resources/icons/left_arrow.svg"
								alt="Atras"
							/>
							<img
								className="footer_icon_web"
								src="resources/icons/left_arrow_web.svg"
								alt="Atras"
							/>
						</button>
						<button
							className={
								"nav_next kensei_03" +
								(disabledButton ? " disabled" : "")
							}
							onPointerDown={goToNextPage}
						>
							{(route === "selectDateTime" &&
								FLOW === "mapfre") ||
							(route === "bookingEnd" && FLOW === "web") ? (
								<p className="footer_p">{t("Confirmar")}</p>
							) : (
								<p className="footer_p">{t("Adelante")}</p>
							)}
							<img
								className="footer_icon"
								src="resources/icons/right_arrow.svg"
								alt="Adelante"
							/>
							<img
								className="footer_icon_disabled"
								src="resources/icons/right_arrow_disabled.svg"
								alt="Adelante"
							/>
							<img
								className="footer_icon_web"
								src="resources/icons/right_arrow_web.svg"
								alt="Adelante"
							/>
							<img
								className="footer_icon_web_disabled"
								src="resources/icons/right_arrow_web_disabled.svg"
								alt="Adelante"
							/>
						</button>
					</div>
				</div>
			</footer>

			<PopupCall />
			<PopupClientEdit />
		</>
	);
};
